import Colors from "../../../Constants/Colors";
import "./../../../Constants/CommonStyle.css";
import Header from "../../../Components/Header/Header";
import { useDispatch } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { getApiContactUsList } from "../../../Core/Apicall";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../Config/Actions/loadingActions";
import EmptyData from "../../../Components/EmptyData/EmptyData";

const ContactUs = () => {
  const dispatch = useDispatch();
  const [contactUs, setContactUs] = useState([]);
  const [totalPaginationOrder, setTotalPaginationOrder] = useState(0);
  const [pageComments, setPageComments] = useState(0);
  const commentsContainerRef = useRef(null);

  useEffect(() => {
    onGetInquiryList();
  }, [pageComments]);

  const onGetInquiryList = async () => {
    let param = {
      offset: 30 * pageComments,
      limit: 30,
    };
    try {
      dispatch(setLoadingTrue());
      const response = await getApiContactUsList(param);
      setContactUs((prevData) => [...prevData, ...response?.inquiries]);
      setTotalPaginationOrder(Math.ceil(response.total / 30));
      dispatch(setLoadingFalse());
    } catch (err) {
      dispatch(setLoadingFalse());
    }
  };
  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } =
      commentsContainerRef?.current;
    if (scrollTop + clientHeight + 1 > scrollHeight) {
      if (totalPaginationOrder > pageComments + 1) {
        setPageComments(pageComments + 1);
      }
    }
  };

  const renderCouponContent = () => {
    return (
      <div className="list-user-div-parent-container-coupon">
        <div
          style={{
            width: "30%",
          }}
          className="fontSize16WithoutFlex"
        >
          Name
        </div>
        <div
          style={{
            width: "30%",
          }}
          className="fontSize16WithoutFlex"
        >
          Email
        </div>
        <div
          style={{
            width: "40%",
          }}
          className="fontSize16WithoutFlex"
        >
          Message
        </div>
        <div style={{ width: "1.1px" }}></div>
      </div>
    );
  };
  const renderCouponList = () => {
    return (
      <div
        style={{ maxHeight: "75vh" }}
        ref={commentsContainerRef}
        onScroll={handleScroll}
        className="scrollable-container"
      >
        {contactUs.map((item, index) => {
          return (
            <div
              key={index}
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignSelf: "stretch",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  alignSelf: "stretch",
                  padding: "1rem",
                  boxSizing: "border-box",
                  gap: "0.5rem",
                }}
              >
                <div
                  style={{
                    width: "30%",
                    overflowWrap: "break-word",
                  }}
                  className="itemTextDisplay"
                >
                  {item.name}
                </div>

                <div
                  style={{
                    width: "30%",
                    overflowWrap: "break-word",
                  }}
                  className="itemTextDisplay"
                >
                  {item.email}
                </div>

                <div
                  style={{
                    width: "40%",
                    overflowWrap: "break-word",
                  }}
                  className="itemTextDisplay"
                >
                  {item.message}
                </div>
              </div>
              <div className="borderTopStyle" />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div
      style={{
        padding: 20,
        backgroundColor: Colors.darkBlack,
      }}
    >
      <Header name={"Contact Us"} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          gap: "1rem",
          flex: 1,
          alignSelf: "stretch",
        }}
      >
        <div
          style={{ alignSelf: "stretch" }}
          className="list-user-div-container"
        >
          {renderCouponContent()}
          {renderCouponList()}
        </div>
        {contactUs?.length == 0 && <EmptyData />}
      </div>
    </div>
  );
};

export default ContactUs;
